module.exports = __webpack_public_path__ + "static/media/location1.8dc3c40c.png";